import React from "react";
import { logOutUser } from "../../services/LocalStorageService";
import { useStyles } from "../../assets/jss/views/Auth";
import { useHistory } from "react-router-dom";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import { useTranslation } from "react-i18next";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
export default function Logout(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const classes = useStyles();
  React.useEffect(() => {
    async function doLogout() {
      return await logOutUser();
    }
    setTimeout(function () {
      doLogout();
      history.push("/login", {from: '/'});
    }, 1500);
  }, []);
  return (
    <>
      <CustomBox className={classes.boxWrapper}>
        <CustomBox className={classes.titleWrap}>
          <CustomTypography
            component="h1"
            variant="h5"
            className={classes.title}
          >
            {t("SignOutFromYourAccount")}
          </CustomTypography>
          
        </CustomBox>
        <CustomBox className={classes.centerLoader}>
          <CustomCircularProgress />
        </CustomBox>
      </CustomBox>
    </>
  );
}
